<template>
  <div>
    <SlideShowSection />
    <LatestProductsSection />
    <BannersSection />
    <BreakfastProductsSection />
    <RomanticProductsSection />
    <ChocolateProductsSection />
    <TestimonialsSection />
  </div>
</template>

<script>
import SlideShowSection from "../components/sections/SlideShowSection.vue";
import LatestProductsSection from "../components/sections/LatestProductsSection.vue";
import BannersSection from "../components/sections/BannersSection.vue";
import BreakfastProductsSection from "../components/sections/BreakfastProductsSection.vue";
import RomanticProductsSection from "../components/sections/RomanticProductsSection.vue";
import ChocolateProductsSection from "../components/sections/ChocolateProductsSection.vue";
import TestimonialsSection from "../components/sections/TestimonialsSection.vue";

export default {
  components: {
    SlideShowSection,
    LatestProductsSection,
    BannersSection,
    BreakfastProductsSection,
    RomanticProductsSection,
    ChocolateProductsSection,
    TestimonialsSection,
  },
};
</script>
